import getWallet from "./getWallet"
import claimDaily from "./claimDaily"
import getShop from "./getShop"
import buyRace from "./buyRace"
import buyCosmetic from "./buyCosmetic"
import equipCosmetic from "./equipCosmetic"
import createOrder from "./createOrder"
import captureOrder from "./captureOrder"

// This is needed for the slice to parse and fullfill the actions when
// the thunks are successfully processed + handling error/loading state
const allThunks = { getWallet, claimDaily, getShop, buyRace, buyCosmetic, equipCosmetic, createOrder, captureOrder }
export default allThunks

// This export is to improve the readability of the code when importing the actions
// from the components that use the thunks.
const getWalletThunk = getWallet.thunk
const claimDailyThunk = claimDaily.thunk
const getShopThunk = getShop.thunk
const buyRaceThunk = buyRace.thunk
const buyCosmeticThunk = buyCosmetic.thunk
const equipCosmeticThunk = equipCosmetic.thunk
const createOrderThunk = createOrder.thunk
const captureOrderThunk = captureOrder.thunk
export {
  getWalletThunk as getWallet,
  claimDailyThunk as claimDaily,
  getShopThunk as getShop,
  buyRaceThunk as buyRace,
  buyCosmeticThunk as buyCosmetic,
  equipCosmeticThunk as equipCosmetic,
  createOrderThunk as createOrder,
  captureOrderThunk as captureOrder,
}
